import { Button, Upload } from "antd"
import styles from "./index.module.scss"
import { useCallback } from "react"
import Utils from '@utils/utils';
import { useNavigate, useParams } from "react-router-dom";
import API, { commonApiInvoker } from "@api/api";
import { SERVICE_OPTIONS } from '@utils/CONST'
import SampleModal from '../SampleModal'

export default function UploadBox (props) {
    const {projectType, onUpload} = props

    const uploadDebounce = useCallback(_.debounce(async (_, fileList) => {
        if(props.setUploadOpen) props.setUploadOpen(false) // 关闭追加商品弹窗
        onUpload(_, fileList)
    }, 100), [])
    const beforeUpload = async (file, fileList) => {
        console.log('===beforeUpload===')
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    return (
        <div className={styles.Container}>
            <Upload.Dragger
                className={styles.Uploader}
                accept='image/jpeg,image/png,image/webp,image/avif'
                listType="picture-card"
                showUploadList={false}
                multiple
                beforeUpload={beforeUpload}
                onDrop={handleDrop}
            >
                <div className={styles.UploaderContent}>
                    <div className={styles.CrossIcon}></div>
                    <span>将图片拖拽至此区域上传图片</span>
                    <Button type="primary" className={styles.UploadBtn}>批量上传{projectType === 'tryonBatch' ? '商品图' : '模特图'}</Button>
                </div>
            </Upload.Dragger>
            <div className={styles.UploadTips}>
                <p>图片上传说明：</p>
                <p>一个项目最多上传50件商品，每张上传图视为一件商品，图片小于等于30M，分辨率不小于500*500px</p>
                <SampleModal showValue={projectType} />
            </div>
        </div>
    )
}